<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form class="form" @submit.prevent="submitData">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('projects.fiches.select_info') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="resetData">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>

          <div class="modal-body" style="overflow-y: auto; max-height: 500px !important;">
            <div class="row">
              <div class="col-12 col-md-4 mb-5" v-for="(select, index) in infoNotExistData" :key="index">
                <div class="rounded-2 p-5" style="border: 1px solid var(--bs-primary);">
                  <div class="form-check form-check-custom form-check-solid">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'flexCheckDefault'+index"
                      :checked="isSelected(select.value)"
                      @change="selectInfo(select)"
                    />
                    <label class="form-check-label" :for="'flexCheckDefault'+index">
                      {{ select[locale] }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <Button
              type="cancel"
              @click="resetData"
              :id="id + '_close_btn'"
              btn-class="btn-sm me-3"
              size="7px 30px"
              btn-text="button.close"
            />
            <Button
              type="submit"
              :id="id + '_save_btn'"
              btn-class="btn-sm me-3"
              size="7px 30px"
              btn-text="projects.fiches.generate"
              :isLoading="isLoadingSelectInfo"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, computed, watch } from 'vue'
import Button from "@/components/Button.vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { useLocales } from '@/composables/locales'

const store = useStore()
const route = useRoute()
const router = useRouter()

const { locale } = useLocales()

const emits = defineEmits(['load'])

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  fiche: {
    type: Object,
    default: {}
  }
})

const infoData = computed(() => store.getters['projects/getProjectSheetEnum'])
const detailFields = computed(() => props.fiche?.details?.map(item => item.field))
const infoNotExistData = computed(() => {
  return infoData.value?.filter(item => !detailFields.value?.includes(item.value))
})

const formSelectInfoData = ref({
  project_id: '',
  summary_id: '',
  details: []
})
const isLoadingSelectInfo = ref(false)

function reset() {
  formSelectInfoData.value = {
    project_id: '',
    summary_id: '',
    details: []
  }
}

watch(
  () => props.fiche,
  (value) => {
    formSelectInfoData.value.details = props.fiche?.details?.map((item) => {
      let field = item.field
      return {...item, field: field, id: field}
    })
  },
  { deep: true }
)

function isSelected(value) {
  return formSelectInfoData.value.details?.some(item => item.id === value)
}

function selectInfo(data) {
  const index = formSelectInfoData.value.details?.findIndex(item => item.id === data.value)
  if (index > -1) {
    formSelectInfoData.value.details?.splice(index, 1)
  } else {
    formSelectInfoData.value.details.push({
      id: data.value,
      is_generated: false,
      field: data.value,
      data: []
    })
  }
}

function resetData() {
  closeModal()
  reset()
}

function submitData() {
  isLoadingSelectInfo.value = true
  formSelectInfoData.value.project_id = route.params.id
  formSelectInfoData.value.summary_id = props.fiche?.id 
  let action = props.fiche?.id  ? 'projects/updateProjectSummary' : 'projects/storeProjectSummary'

  store.dispatch(action, formSelectInfoData.value)
      .then(res => {
        emits('load')
        router.replace({ query: { ...route.query, detail: 'generate' } });
        window.toastr["success"](i18n.global.t('notification.fiche_generated'));
        resetData()
      })
      .finally(() => isLoadingSelectInfo.value = false)
 
}

function closeModal() {
  $('#' + props.id).modal('toggle')
}

function loadEnum() {
  store.dispatch('projects/loadSheetSummary')
}

onMounted(() => {
  if (route.query.tab === 'kt_fiches') {
    loadEnum()
  }
})
</script>
